import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { RIEInput } from 'riek'
import { Droppable } from 'react-beautiful-dnd'

import { capitalize, getStageElementsByTypes } from '../../functions'

class Input extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.value !== this.props.value) return true
    if (nextProps.propName !== this.props.propName) return true
    if (nextProps.className !== this.props.className) return true
    if (nextState !== this.state) return true
    return false
  }

  render() {
    const { value, propName, className } = this.props

    return (
      <RIEInput
        value={value}
        propName={propName}
        className={className}
        classEditing="riek-editing"
        change={(propValue) => this.props.change(propValue)} />
    )
  }
}

class Contact extends Component {
  constructor(props) {
    super(props)

    this.state = {
      title: '',
      name: '',
      description: '',
      email: '',
      phone: '',
      showDropdown: false,
      focus: false,
      error: ''
    }

    this.input = React.createRef()
  }

  componentWillMount() {
    const { contact } = this.props
    const { title, name, description, email, phone } = contact

    this.setState({title, name, description, email, phone})
  }

  componentDidMount() {
    const { contact } = this.props

    if (contact.id === undefined) this.input.current.startEditing()
  }

  componentWillReceiveProps(nextProps) {
    const { contact } = nextProps

    if (contact !== this.props.contact) {
      const { title, name, description, email, phone } = contact

      this.setState({title, name, description, email, phone})
    }
  }

  contactIsUpdated() {
    const { id } = this.props.contact
    const { title, name, description, email, phone } = this.state

    if (id) {
      this.props.editRiderContact({id, title, name, description, email, phone})
    } else {
      this.props.createRiderContact({title, name, description, email, phone})
    }
  }

  renderDropdown(contact) {
    const { showDropdown } = this.state

    const className = classnames({
      'ui-dropdown': true,
      'ui-dropdown--active': showDropdown
    })

    return (
      <div className={className}>
        {showDropdown === true ? <div className="ui-dropdown-escape" onClick={() => this.setState({showDropdown: !showDropdown})} /> : null}

        <div className="ui-dropdown-handle" onClick={() => this.setState({showDropdown: !showDropdown})} />

        {
          showDropdown === true
          ? <ul className="ui-dropdown-content">
              <li onClick={() => this.setState({showDropdown: false}, () => this.props.deleteRiderContact(contact))}>Remove this contact</li>
            </ul>
          : null
        }
      </div>
    )
  }

  renderContact() {
    const { view, contact, position, isDragging, stageElements } = this.props
    const { title, name, description, phone, showDropdown, focus, error } = this.state

    const className = classnames({
      'card': true,
      'card--focus': showDropdown || focus,
      'contact': true
    })

    const nameClassName = classnames({
      'riek': true,
      'name': true,
      'h4': true,
      'placeholder': !name
    })

    const titleClassName = classnames({
      'riek': true,
      'title': true,
      'placeholder': !title
    })

    const phoneClassName = classnames({
      'riek': true,
      'phone': true,
      'placeholder': !phone
    })

    const droppableClassName = isDraggingOver => classnames({
      'contact--droppable': true,
      'contact--droppable-dragging': isDragging,
      'contact--droppable-dragging-over': isDraggingOver
    })

    return (
      <li className={className}>
        <div className="card-content" data-number={position} data-error={error}>
          {
            view.editable
            ? this.renderDropdown(contact)
            : null
          }

          {
            view.editable
            ? <Input
                value={name || ''}
                propName="name"
                className={nameClassName}
                change={({name}) => {
                  name
                  ? this.setState({name}, () => this.contactIsUpdated())
                  : this.setState({name: contact.name})
                }} />
            : <div className={nameClassName}>{name}</div>
          }

          <label className="enter">Enter</label>

          {
            view.editable
            ? <Input
                value={title || 'Add a position'}
                propName="title"
                className={titleClassName}
                change={({title}) => this.setState({title}, () => this.contactIsUpdated())} />
            : <div className={titleClassName}>{title}</div>
          }

          {
            view.editable
            ? <Input
                value={phone || 'Add a phone number'}
                propName="phone"
                className={phoneClassName}
                change={({phone}) => this.setState({phone}, () => this.contactIsUpdated())} />
            : <div className={phoneClassName}>{phone}</div>
          }
        </div>
      </li>
    )
  }

  renderEmptyContact() {
    const { view, position } = this.props
    const { name, error } = this.state

    const className = classnames({
      'card': true,
      'card--focus': true
    })

    if (view.editable !== true) return null

    return (
      <li className={className}>
        <div className="card-escape" onClick={() => this.props.removeRiderContact(position-1)} />

        <div className="card-content" data-number={position} data-error={error} tabIndex="0"
          onKeyDown={(e) =>
            e.key === 'Enter'
            ? setTimeout(() => {
                const { name } = this.state

                this.setState({
                  error:
                    !name
                    ? 'Please insert a name'
                    : null
                }, () => {
                  name
                  ? this.contactIsUpdated()
                  : this.input.current.startEditing()
                })
              }, 1) // add setTimeout as change and onKeyDown are fired asynchronously
            : e.key === 'Escape'
              ? this.props.removeRiderContact(position-1)
              : null
          }>
          <div className="riek-escape" onClick={() => this.props.removeRiderContact(position-1)} />

          <RIEInput
            ref={this.input}
            value={name || ''}
            propName="name"
            className="riek riek-editing name h4"
            change={({name}) => this.setState({name: capitalize(name)})} />

          <label className="enter" onClick={() => {
            this.setState({
              error:
                !name
                ? 'Please insert a name'
                : null
            }, () => {
              name
              ? this.contactIsUpdated()
              : this.input.current.startEditing()
            })
          }}>Enter</label>
          <div className="remove-contact" onClick={() => this.props.removeRiderContact(position-1)} />

          <p>Add new contact</p>
        </div>
      </li>
    )
  }

  render() {
    const { contact } = this.props

    return contact.id !== undefined
    ? this.renderContact()
    : this.renderEmptyContact()
  }
}

Contact.propTypes = {
  view: PropTypes.object,
  contact: PropTypes.object,
  position: PropTypes.number,
  isDragging: PropTypes.bool,
  createRiderItem: PropTypes.func,
  removeRiderContact: PropTypes.func,
  createRiderContact: PropTypes.func,
  editRiderContact: PropTypes.func,
  deleteRiderContact: PropTypes.func,
  availableItems: PropTypes.array,
  stageElements: PropTypes.object,
  searchResults: PropTypes.array,
  getSearchResults: PropTypes.func,
  setAlert: PropTypes.func
}

Contact.defaultProps = {
  view: {},
  contact: {},
  position: 0,
  isDragging: false,
  createRiderItem: function() {},
  removeRiderContact: function() {},
  createRiderContact: function() {},
  editRiderContact: function() {},
  deleteRiderContact: function() {},
  availableItems: [],
  stageElements: {},
  searchResults: undefined,
  getSearchResults: function() {},
  setAlert: function() {}
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/rider/rider-contacts/contact.js